import DOCUMENT_CONFIGS from './documentsVerificationConstants';

export default [
    {
        events: [
            DOCUMENT_CONFIGS.CHANGE_IN_ADDRESS,
            DOCUMENT_CONFIGS.CHANGE_IN_ADDRESS_FUTURE,
            DOCUMENT_CONFIGS.MOVED_INTO_STATE,
            DOCUMENT_CONFIGS.MOVED_INTO_STATE_FUTURE,
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_EXISTING_COVERAGE,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.INSURANCE_LETTER_COV,
                    DOCUMENT_CONFIGS.GOV_LETTER_GOV,
                    DOCUMENT_CONFIGS.COBRA_COV,
                    DOCUMENT_CONFIGS.PAY_STUB_COV,
                    DOCUMENT_CONFIGS.MARKETPLACE_COV,
                    DOCUMENT_CONFIGS.STUDENT_LETTER_COV,
                ],
            },
            {
                categoryType: DOCUMENT_CONFIGS.ADDRESS_PROOF,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.US_POSTAL_LETTER,
                    DOCUMENT_CONFIGS.MORTGAGE_DOCUMENT,
                    DOCUMENT_CONFIGS.RENTAL_AGREEMENT,
                    DOCUMENT_CONFIGS.MOVED_INTO_THE_US,
                    DOCUMENT_CONFIGS.VOTER_CARD,
                    DOCUMENT_CONFIGS.INSURANCE_LETTER_ADDR,
                    DOCUMENT_CONFIGS.UTILITY_BILLS,
                    DOCUMENT_CONFIGS.GOVT_LETTER_ADDR,
                    DOCUMENT_CONFIGS.REF_LETTER_ADDR,
                ],
            },
        ],
    },
    {
        events: [DOCUMENT_CONFIGS.MARRIAGE],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_MARRIAGE,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.C6_MARRIAGE,
                    DOCUMENT_CONFIGS.AFFIDAVIT_MARRIAGE,
                    DOCUMENT_CONFIGS.MARRIAGE_CERTIFICATE,
                    DOCUMENT_CONFIGS.PBLC_RCRD_MARRIAGE,
                ],
            },
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_EXISTING_COVERAGE,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.INSURANCE_LETTER_COV,
                    DOCUMENT_CONFIGS.GOV_LETTER_GOV,
                    DOCUMENT_CONFIGS.COBRA_COV,
                    DOCUMENT_CONFIGS.PAY_STUB_COV,
                    DOCUMENT_CONFIGS.MARKETPLACE_COV,
                    DOCUMENT_CONFIGS.STUDENT_LETTER_COV,
                ],
            },
        ],
    },
    {
        events: [DOCUMENT_CONFIGS.DIVORCE, DOCUMENT_CONFIGS.DIVORCE_OR_ANULLMENT],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_LOSS_OF_DEPENDENT,
                documentsQty: 1,
                documentTypes: [DOCUMENT_CONFIGS.LEGAL_SEPARATION_DOC, DOCUMENT_CONFIGS.DIVORCE_DECREE],
            },
        ],
    },
    {
        events: [DOCUMENT_CONFIGS.HRA, DOCUMENT_CONFIGS.HRA_FUTURE],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_HRA,
                documentsQty: 1,
                documentTypes: [DOCUMENT_CONFIGS.HRA_EMPLOYER_NOTICE],
            },
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.EMPLOYER_SPONSORED_COVERAGE_UNAFFORDABLE,
            DOCUMENT_CONFIGS.INCREASE_IN_SUBSIDY_EMPLOYER_PLAN_CHANGE,
            DOCUMENT_CONFIGS.INCREASE_IN_SUBSIDY_EMPLOYER_PLAN_CHANGE_FUTURE,
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_EMPLOYER_PLAN,
                documentsQty: 1,
                documentTypes: [DOCUMENT_CONFIGS.ESC_EMPLOYER_PLAN_DETAILS],
            },
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.ERROR_ASSISTER_BROKER,
            DOCUMENT_CONFIGS.ERROR_DUE_TO_ASSISTER_OR_BROKER,
            DOCUMENT_CONFIGS.ERROR_DUE_TO_EXCHANGE,
            DOCUMENT_CONFIGS.ERROR_EXCHANGE,
            DOCUMENT_CONFIGS.ERROR_HEALTH_PLAN_VIOLATION,
            DOCUMENT_CONFIGS.ERROR_PLAN_BENEFIT_DISPLAY,
            DOCUMENT_CONFIGS.ERROR_PLAN_OR_BENEFIT_DISPLAY,
            DOCUMENT_CONFIGS.EXCEPTIONAL_CIRCUMSTANCES_INDIVIDUAL,
            DOCUMENT_CONFIGS.EXCEPTIONAL_CIRCUMSTANCES_NATURAL_DISASTER,
            DOCUMENT_CONFIGS.EXCEPTIONAL_CIRCUMSTANCES_SYSTEM_BACKLOG,
            DOCUMENT_CONFIGS.EXCEPTIONAL_CIRCUMSTANCES_SYSTEM_ERROR,
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.DOC_INDICATING_EXCEPTIONS,
                documentsQty: 1,
                documentTypes: [DOCUMENT_CONFIGS.OTHER_EXCEPTIONS],
            },
        ],
    },
    {
        events: [DOCUMENT_CONFIGS.SURVIVOR_OF_DOMESTIC_ABUSE_OR_SPOUSAL_ABANDONMENT],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_EXISTING_COVERAGE,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.INSURANCE_LETTER_COV,
                    DOCUMENT_CONFIGS.GOV_LETTER_GOV,
                    DOCUMENT_CONFIGS.COBRA_COV,
                    DOCUMENT_CONFIGS.PAY_STUB_COV,
                    DOCUMENT_CONFIGS.MARKETPLACE_COV,
                    DOCUMENT_CONFIGS.STUDENT_LETTER_COV,
                ],
            },
        ],
    },
    {
        events: [DOCUMENT_CONFIGS.INCREASE_IN_SUBSIDY_INCOME_CHANGE],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_INCOME_CHANGE,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.INCOME_1040,
                    DOCUMENT_CONFIGS.W2_INCOME,
                    DOCUMENT_CONFIGS.PAY_STUB_INCOME,
                    DOCUMENT_CONFIGS.SELF_EMP_INCOME,
                    DOCUMENT_CONFIGS.SSA_INCOME,
                    DOCUMENT_CONFIGS.UNEMP_INCOME,
                ],
            },
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_EXISTING_COVERAGE,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.INSURANCE_LETTER_COV,
                    DOCUMENT_CONFIGS.GOV_LETTER_GOV,
                    DOCUMENT_CONFIGS.COBRA_COV,
                    DOCUMENT_CONFIGS.PAY_STUB_COV,
                    DOCUMENT_CONFIGS.MARKETPLACE_COV,
                    DOCUMENT_CONFIGS.STUDENT_LETTER_COV,
                ],
            },
        ],
    },
    {
        events: [DOCUMENT_CONFIGS.CHANGE_IN_LEGAL_PRESENCE],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_CURRENT_LEGAL_STATUS,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.US_PASSPORT,
                    DOCUMENT_CONFIGS.CERT_CITIZENSHIP,
                    DOCUMENT_CONFIGS.I551,
                    DOCUMENT_CONFIGS.I94,
                    DOCUMENT_CONFIGS.I94_UNEXP,
                    DOCUMENT_CONFIGS.CTZN_ID_CARD,
                    DOCUMENT_CONFIGS.DOC_REFUGEE_SETTLEMENT,
                    DOCUMENT_CONFIGS.UNEXP_PASSPORT,
                    DOCUMENT_CONFIGS.I571,
                    DOCUMENT_CONFIGS.BIRTH_CERTIFICATE,
                    DOCUMENT_CONFIGS.I766,
                    DOCUMENT_CONFIGS.I688B,
                    DOCUMENT_CONFIGS.I688A,
                    DOCUMENT_CONFIGS.I688,
                    DOCUMENT_CONFIGS.I20,
                    DOCUMENT_CONFIGS.DS2019,
                    DOCUMENT_CONFIGS.TEMP_I551_STAMP,
                    DOCUMENT_CONFIGS.TRIBAL_BIRTH,
                    DOCUMENT_CONFIGS.ACT_2000_BIRTH,
                    DOCUMENT_CONFIGS.ABROAD_BIRTH,
                    DOCUMENT_CONFIGS.MARINAS_ID_CARD,
                    DOCUMENT_CONFIGS.DRIVER_LICENSE,
                    DOCUMENT_CONFIGS.MIL_RECORD_BIRTH,
                    DOCUMENT_CONFIGS.CENSUS_REC_BIRTH,
                    DOCUMENT_CONFIGS.ADOPTION_DECREE,
                    DOCUMENT_CONFIGS.MEDICAL_RECORDS_BIRTH,
                    DOCUMENT_CONFIGS.US_CIVIL_SERVICES_BIRTH,
                    DOCUMENT_CONFIGS.CIRT_REPORTING_BIRTH,
                    DOCUMENT_CONFIGS.PASS_CARD,
                    DOCUMENT_CONFIGS.SCHOOL_REC_BIRTH,
                    DOCUMENT_CONFIGS.I327,
                    DOCUMENT_CONFIGS.I360,
                    DOCUMENT_CONFIGS.DOC_WITHHOLD_REMOVAL,
                    DOCUMENT_CONFIGS.ADMIN_STAY_DHS,
                    DOCUMENT_CONFIGS.RELEGIOUS_REC_BIRTH,
                ],
            },
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.CHANGE_IN_AI_AN_STATUS,
            DOCUMENT_CONFIGS.GAIN_OF_AMERICAN_INDIAN_STATUS,
            DOCUMENT_CONFIGS.GAIN_OF_AI_AN,
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_TRIBAL,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.TRIBAL_CARD,
                    DOCUMENT_CONFIGS.TRIBAL_DOCUMENT,
                    DOCUMENT_CONFIGS.TRIBAL_MEMBERSHIP,
                    DOCUMENT_CONFIGS.CERT_INDIAN_ALASKAN_BLOOD_FROM_BIA,
                    DOCUMENT_CONFIGS.TRIBAL_CENSUS_DOCUMENT,
                    DOCUMENT_CONFIGS.DOCUMENT_INDICATING_TRIBAL_AFFILIATION,
                ],
            },
        ],
    },
    {
        events: [DOCUMENT_CONFIGS.ADOPTION, DOCUMENT_CONFIGS.GAIN_COURT_APPOINTED_DEPENDENT],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_GAIN_OF_DEPENDENT,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.COURT_ORDER_INDICATING_ADD_REMOVE,
                    DOCUMENT_CONFIGS.COURT_ORDER_CHILD_SUPPORT,
                    DOCUMENT_CONFIGS.COURT_ORDER,
                ],
            },
        ],
    },
    {
        events: [DOCUMENT_CONFIGS.BIRTH, DOCUMENT_CONFIGS.DOB_CHANGE],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_BIRTH,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.BIRTH_CERTIFICATE,
                    DOCUMENT_CONFIGS.CIRT_REPORTING_BIRTH,
                ],
            },
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.LOSS_OF_MEC,
            DOCUMENT_CONFIGS.LOST_OTHER_MIN_ESSENTIAL_COVERAGE_FUTURE,
            DOCUMENT_CONFIGS.LOST_OTHER_MIN_ESSENTIAL_COVERAGE,
            DOCUMENT_CONFIGS.LOSS_OF_COVERAGE_THROUGH_EMPLOYER_FUTURE,
            DOCUMENT_CONFIGS.LOSS_OF_COVERAGE_THROUGH_EMPLOYER
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_LOSS_OF_COVERAGE,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.PRIOR_EMPLYR_LOSS_OF_COVERAGE,
                    DOCUMENT_CONFIGS.EMPLYR_COVERAGE_OFFER,
                    DOCUMENT_CONFIGS.HEALTH_INSURANCE_COVERAGE_OFFER,
                    DOCUMENT_CONFIGS.GOVT_INSURANCE_COVERAGE_OFFER,
                ],
            },
        ],
    },
    {
        events: [DOCUMENT_CONFIGS.CHANGE_IN_INCARCERATION, DOCUMENT_CONFIGS.INCARCERATION],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_INCARCERATION_STATUS,
                documentsQty: 1,
                documentTypes: [DOCUMENT_CONFIGS.INCARCERATION_RELEASE_DOC],
            },
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.ICHRA_SEP,
            DOCUMENT_CONFIGS.ICHRA_SEP_FUTURE,
            DOCUMENT_CONFIGS.QSEHRA_SEP,
            DOCUMENT_CONFIGS.QSEHRA_SEP_FUTURE,
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_HRA_OFFER,
                documentsQty: 1,
                documentTypes: [DOCUMENT_CONFIGS.HRA_OFFER_DOCUMENT],
            },
        ],
    },
    {
        events: [DOCUMENT_CONFIGS.UNSUPPORTED_EVENT],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.DOC_PROVING_EVENT,
                documentsQty: 1,
                documentTypes: [DOCUMENT_CONFIGS.DOC_SUPPORTING_EVENT],
            },
        ],
    },
];
